require('./brokerStocksBuySuccess.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount, formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const { getInstitutionDescOfMarket } = require('utilities/micCodeHelper');
const momentTz = require('moment-timezone');


// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @helpers
const DateHelper = require('utilities/dateHelper');
const { recordLinkV2 } = require("utilities/tagging");

// @contants
const { MYPROFILE_BROKER_URL, MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL } = require('constants/index');

const {
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_LIMITED,
    DATE_FORMAT_COMPLETE,
    BROKER_TYPE_STOCKS_NEW_DECIMALS
} = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/brokerStocksBuy.tracking');

class BrokerStocksBuySuccess extends React.Component {

    componentDidMount() {
        recordLinkV2(catalogue[analyticsId.BROKER_STOCK_BUY_STEP_2_SUCCESS]());
    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('broker-stocksBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('broker-stocksBuyStep1ForTheBestLabel');
        } else {
            return formatText('broker-stocksBuyStep1LimitedLabel');
        }
    }

    buildOrderTypeSection() {
        const { immStocksBuy, productFile } = this.props;
        const orderType = immStocksBuy.getIn(['steps', FIRST_STEP, 'orderType']);
        const orderTypeLabel = formatText('broker-stocksBuySellSummaryStockTypeTitle');

        let result;

        if (orderType === BROKER_ORDER_TYPE_LIMITED) {
            const amount = immStocksBuy.getIn(['steps', FIRST_STEP, 'orderTypeLimited']);
            const currency = productFile.get('currency');
            const amountFormatted = getFormattedString({
                amount,
                currency,
                decimalsLength: BROKER_TYPE_STOCKS_NEW_DECIMALS
            });
            const limitedText = formatText('broker-stocksBuySellSummaryLimitedStockValue');
            const formatedTextAmount = `${limitedText} (${amountFormatted})`;

            result = (
                <OKInformativeListItem
                    title={orderTypeLabel.toUpperCase()}
                    bodyText={formatedTextAmount}
                />
            );
        } else {
            const orderTypeText = this.getOrderType(orderType);

            result = (
                <OKInformativeListItem
                    title={orderTypeLabel.toUpperCase()}
                    bodyText={orderTypeText}
                />
            );
        }

        return result;
    }

    render() {
        const { productFile, immStocksContracts, immStocksBuy, isin } = this.props;

        const orderNumber = immStocksBuy.getIn(['orderConfirmation', 'orderNumber']);

        const stockName = productFile.get('companyName');
        const dateFormat = formatText('broker-stocksLikeHeaderDateFormat');
        const validityDate = immStocksBuy
            .getIn(['steps', FIRST_STEP, 'validityDate'])
            .format(dateFormat);
        const selectedOption = immStocksBuy.getIn([
            'steps',
            FIRST_STEP,
            'stocksContractSelectedValue'
        ]);
        const selectedAccount = immStocksContracts.get(selectedOption);
        const micCode = productFile.get('micCode');
        const marketInfo = getInstitutionDescOfMarket(micCode);
        const accountNumber = immStocksBuy.getIn(['orderConfirmation', 'associatedAccount']);
        const contractNumber = selectedAccount.get('walletNumber');
        const productNumber = selectedAccount.get('productNumber');
        const controlDigit = selectedAccount.get('controlDigit');
        const walletBalance = immStocksBuy.getIn(['orderConfirmation', 'accountBalance']);
        const walletCurrency = immStocksBuy.getIn(['orderConfirmation', 'accountCurrency']);
        const formattedAmount = formatAmount(walletBalance);
        const formattedCurrency = formatCurrency(walletCurrency);
        const accountOwner = selectedAccount.get('firstTitular');
        const accountName = selectedAccount.get('associatedAccountAlias');
        const contractName = selectedAccount.get('walletAccountType');
        const associatedAccountBalance =
            formatText('stocksContract-accountBalance') +
            ': ' +
            formattedAmount +
            ' ' +
            formattedCurrency; //@hardcoded and mocked 'til we receive this from the reducer
        const titlesAmount = immStocksBuy.get('confirmationData').titulosImporteAproximado;

        const holdings = `${titlesAmount} ${formatText('stocksContract-holdings')}`;
        const emissionDate = DateHelper.buildFormattedDate(
            momentTz(immStocksBuy.get('emmisionDate')).tz("Europe/Madrid"),
            DATE_FORMAT_COMPLETE
        );

        const successTitle = formatText('stocksContract-successTitle');
        const successMessage = formatText('stocksContract-simpleBuySuccessMessage');
        const successSubMessage = `${formatText('stocksContract-orderNumber')} ${orderNumber}`;
        const mainButtonLabel = formatText('stocksContract-backToWallet');
        const secondaryButtonLabel = formatText('stocksContract-reviewOrders');
   
        const orderTypeSection = this.buildOrderTypeSection();

        return (
            <WizardSuccess
                successTitle={successTitle}
                successMessage={successMessage}
                successSubMessage={successSubMessage}
                customClassName="stocks-buy-success"
                mainButton={{
                    label: mainButtonLabel,
                    url: MYPROFILE_BROKER_URL,
                    modifier: 'secondary'
                }}
                secondaryButton={{
                    label: secondaryButtonLabel,
                    url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL
                }}
                tealium={catalogue[analyticsId.BROKER_STOCK_BUY_SUCCESS]({ productName: isin })}
                isSecondVersion
            >
                <div className="stocks-buy-success__order-data">
                    <div className="stocks-buy-success__order-data-left">
                        <OKInformativeList>
                            <OKInformativeListItem
                                title={formatText('stocksContract-orderBoughtStock')}
                                bodyText={stockName}
                            >
                                <div className="stocks-buy-success__stock-exchange">
                                    {marketInfo}
                                </div>
                            </OKInformativeListItem>
                            <OKInformativeListItem
                                title={formatText('stocksContract-ordersContract')}
                                bodyText={contractName}
                            >
                                <div className="stocks-buy-success__contract-number">
                                    {CHARGE_ACCOUNT_PREFIX}
                                    {controlDigit}
                                    {productNumber}
                                    {contractNumber}
                                </div>

                                <div className="stocks-buy-success__related-account">
                                    <FormattedText value="stocksContract-firstHolder" />:{' '}
                                    {accountOwner} <br />
                                    <FormattedText value="stocksContract-associatedAccount" />:{' '}
                                    {accountName} <br />
                                    {accountNumber} ({associatedAccountBalance})
                                </div>
                            </OKInformativeListItem>
                        </OKInformativeList>
                    </div>
                    <div className="stocks-buy-success__order-data-right">
                        <OKInformativeList>
                            <OKInformativeListItem
                                title={formatText('stocksContract-holdingsTitle')}
                                bodyText={holdings}
                            />
                            {orderTypeSection}
                            <OKInformativeListItem
                                title={formatText('stocksContract-validityTerm')}
                                bodyText={validityDate}
                            />
                            <OKInformativeListItem>
                                <div>
                                    <div className="stocks-buy-success__buying-date-time-title">
                                        <FormattedText value="stocksContract-BuyingDateAndTime" />{' '}
                                        <OKTooltip
                                            content="broker-stocksContract_BuyingDateAndTimeToolTip"
                                            offset={[4, -15]}
                                        />
                                        <br />
                                    </div>
                                    <div className="stocks-buy-success__buying-date-time-body-text">
                                        {emissionDate}
                                    </div>
                                </div>
                            </OKInformativeListItem>
                        </OKInformativeList>
                    </div>
                </div>
            </WizardSuccess>
        );
    }
}

BrokerStocksBuySuccess.propTypes = {
    productFile: PropTypes.object,
    immStocksContracts: PropTypes.object,
    immStocksBuy: PropTypes.object,
    isin: PropTypes.string
};

module.exports = BrokerStocksBuySuccess;
